import { useState, useEffect, useCallback, useContext } from "react";
import { TextField, Button } from "@material-ui/core";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../constants/caption/dashboardHeader";
import { PersonalInformation, BenefitSelection } from "../../../../../../..";
import { HeaderInformation, EmployerSection } from "../../../../../../..";
import { UIContext } from "../../../../../../../../../contexts";

import SendIcon from "@material-ui/icons/Send";

import "./lincolnFormActual.css";
import { LincolnFormActualType } from "../../../../../../../../../@types/lincolnForm.types";
import ApproveActiveEnrollment from "../../../../../../../../shared/approveActiveEnrollment/ApproveActiveEnrollment";
import prefixCharacterAddition from "../../../../../../../../../utils/commonFunctions/prefixCharacterAddition";

const LincolnFormActual = ({
	employerSection,
	employee,
	totalPremium,
	planCode,
	enrollmentDate,
	enrollmentStatus,
	effectiveDate,
	handleApproveEffectiveDateChange,
	handleEnrollmentChange,
	handleEnrollmentDateChange,
	handleRehireDateChange,
	handleCheck
}: LincolnFormActualType) => {
	const { setDashboardHeader } = useContext(UIContext);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.lincoln_enrollment_form);
	}, [setDashboardHeader]);

	return (
		<div className="lincoln-form-actual" id="lincoln-form-actual">
			<div className="header-information" id="header-information">
				<HeaderInformation planCode={planCode} />
			</div>
			<div className="header-container" id="header-container">
				<div className="form-header" id="form-header">
					<span className="header-number" id="header-number">
						1.
					</span>
					Your Personal Information
				</div>
				<div className="personal-informations" id="personal-informations">
					{employee != undefined ? <PersonalInformation employee={employee} /> : null}
				</div>
			</div>
			<div className="header-container" id="header-container">
				<EmployerSection
					employerSection={employerSection}
					handleEnrollmentChange={handleEnrollmentChange}
					handleEnrollmentDateChange={handleEnrollmentDateChange}
					handleRehireDateChange={handleRehireDateChange}
					handleCheck={handleCheck}
				/>
			</div>
			<div className="header-container" id="header-container">
				<div className="form-header" id="form-header">
					<span className="header-number" id="header-number">
						2.
					</span>
					Benefit Selection - Choose your benefits
				</div>
				<div className="benefit-selections" id="benefit-selections">
					<BenefitSelection totalPremium={totalPremium} effectiveDate={effectiveDate} />
				</div>
			</div>
			<div className="header-container" id="header-container">
				<div className="form-header" id="form-header">
					<span className="header-number" id="header-number">
						3.
					</span>
					Confirm Enrollment
				</div>
				<p className="warning-container">
					This group insurance has been offered to me and after careful consideration of the benefits, I have
					decided to:
				</p>
				<div className="checkbox-container">
					<span className="checkbox">
						<input
							type="checkbox"
							id="enroll_insurance"
							name="enroll_insurance"
							// onChange={handleCheck}
							checked={true}
						/>
					</span>
					<span className="enroll-text">ENROLL FOR INSURANCE for which I am or may become eligible </span>
					<span className="enroll-text1">under the group policies issued by The Lincoln National Life </span>
					<p className="paragraph-text2">
						Insurance Company, or its insurance partners. If contributions are required, I authorize my
						Employer to deduct premium from my pay.
					</p>
				</div>
			</div>
			<div className="header-container" id="header-container">
				<div className="form-header" id="form-header">
					<span className="header-number" id="header-number">
						4.
					</span>
					Fraud Warning/State Disclosure(s)
				</div>
				<p className="warning-container">
					ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR THE PAYMENT OF A LOSS IS GUILTY OF
					A CRIME AND MAY BE SUBJECT TO FINES AND CONFINEMENT IN STATE PRISON.
				</p>
			</div>
			<div className="header-container" id="header-container">
				<div className="form-header" id="form-header">
					<span className="header-number" id="header-number">
						5.
					</span>
					Sign & Return
				</div>
				<p className="paragraph-container">
					I understand the group insurance requested will not be effective until approved by the Group
					Insurance Service Office of The Lincoln National Life Insurance Company, or its insurance partners.
					A delayed effective date will apply if you are not Actively at Work/an Active Member. A delayed
					effective date may apply to your dependent, if he or she is confirmed in a hospital or health care
					facility or is in a period of limited actively on the date insurance would otherwise take effect.
				</p>
				<p className="paragraph-container">
					I understand the information provided is for enrollment in group insurance as offered by my Employer
					and will not be used for underwriting purposes.
				</p>
				<p className="paragraph-container">
					The information provided is complete, true, and accurate to the best of my knowledge.
				</p>
				<div className="fullname-container">
					<span className="fullname-header">Your Full Name (Print):</span>
					<span className="textfield-container">
						<TextField
							className="text-field"
							id="text-field"
							name="full_name"
							value={employee.first_name + " " + employee.middle_name + " " + employee.last_name}
							// onChange={handleEnrollmentChange}
							style={{
								width: "700px",
								borderRadius: 50
							}}
							inputProps={{ readOnly: true }}
						/>
					</span>
				</div>
				<div className="signature-container">
					<span className="signature-header">Your Signature:</span>
					<span className="textfield-container">
						<TextField
							className="text-field"
							id="text-field"
							name="signature"
							value={
								employee.first_name +
								" " +
								(employee.middle_name ? employee.middle_name : "") +
								" " +
								employee.last_name
							}
							// onChange={handleEnrollmentChange}
							style={{
								width: "700px",
								borderRadius: 50
							}}
							inputProps={{ readOnly: true }}
						/>
					</span>
					<span className="date-header">Date:</span>
					<span className="date-container">
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="MM"
								name="month"
								value={
									enrollmentDate
										? prefixCharacterAddition(new Date(enrollmentDate).getMonth() + 1)
										: ""
								}
								style={{
									width: "30px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="DD"
								name="day"
								value={
									enrollmentDate ? prefixCharacterAddition(new Date(enrollmentDate).getDate()) : ""
								}
								style={{
									marginLeft: "3px",
									width: "30px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="YYYY"
								name="year"
								value={
									enrollmentDate
										? prefixCharacterAddition(new Date(enrollmentDate).getFullYear())
										: ""
								}
								style={{
									marginLeft: "3px",
									width: "50px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</span>
					</span>
				</div>
			</div>
			<div className="approve-active-enrollment">
				<ApproveActiveEnrollment
					enrollmentDate={enrollmentDate}
					enrollmentStatus={enrollmentStatus}
					effectiveDate={effectiveDate}
					handleApproveEffectiveDateChange={handleApproveEffectiveDateChange}
				/>
			</div>
			{/* <div className="action-button-container" id="action-button-container">
				<Button
					className="lincoln-button-green"
					onClick={handleSubmitClick}
					variant="contained"
					// disabled={hasCreateClick}
					// disableElevation={hasCreateClick}
					// style={{
					// 	cursor: hasCreateClick ? "not-allowed" : "pointer",
					// 	pointerEvents: "unset"
					// }}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div> */}
		</div>
	);
};

export default LincolnFormActual;
